import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

interface ComingSoonPageProps {
  feature: string;
  description?: string;
  icon?: React.ReactNode;
}

export function ComingSoonPage({ feature, description, icon }: ComingSoonPageProps) {
  return (
    <div className="max-w-7xl mx-auto px-page-gutter py-8">
      <div className="flex flex-col items-center justify-center py-24">
        <div className="w-20 h-20 bg-surface-container-low rounded-full flex items-center justify-center mb-6">
          {icon || <ClockIcon className="h-10 w-10 text-on-surface-variant" />}
        </div>
        <h1 className="text-3xl font-semibold tracking-editorial text-on-surface mb-2">{feature}</h1>
        <span className="inline-flex items-center px-4 py-2 bg-warning-container rounded-pill mb-4">
          <ClockIcon className="h-4 w-4 text-warning mr-2" />
          <span className="text-sm font-medium text-warning-on-container">Coming Soon</span>
        </span>
        <p className="text-on-surface-variant text-center max-w-md">
          {description || 'This feature is currently under development and will be available soon.'}
        </p>
      </div>
    </div>
  );
}

interface ComingSoonBadgeProps {
  className?: string;
}

export function ComingSoonBadge({ className = '' }: ComingSoonBadgeProps) {
  return (
    <span className={`ml-1.5 px-2 py-0.5 text-[10px] font-semibold uppercase bg-warning-container text-warning-on-container rounded-pill ${className}`}>
      Soon
    </span>
  );
}

interface ComingSoonOverlayProps {
  children: React.ReactNode;
  label?: string;
}

export function ComingSoonOverlay({ children, label }: ComingSoonOverlayProps) {
  return (
    <div className="relative">
      <div className="opacity-40 pointer-events-none select-none">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="glass inline-flex items-center px-3 py-1.5 rounded-pill shadow-ambient">
          <ClockIcon className="h-3.5 w-3.5 text-warning mr-1.5" />
          <span className="text-xs font-medium text-on-surface-variant">{label || 'Coming Soon'}</span>
        </div>
      </div>
    </div>
  );
}
